export default "__VITE_ASSET__CyIUqBhE__"